import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CustomHeaderComponent } from './custom-header/custom-header.component';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

@Component({
	selector: 'app-dynamic-calendar',
	templateUrl: './dynamic-calendar.component.html',
	styleUrls: ['./dynamic-calendar.component.scss'],
	encapsulation: ViewEncapsulation.None,
	viewProviders: [
		{ provide: ControlContainer, useExisting: FormGroupDirective }
	]
})
export class DynamicCalendarComponent {
	@Input() field: any;
	@Input() minDate: Date | null = null;
	@Input() maxDate: Date | null = null;
	customHeader = CustomHeaderComponent;

	constructor(public controlContainer: ControlContainer) {}
}
